var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_25032)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#3152E7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0, 4)",
    d: "M14.6385 19.4L13.7265 18.872L20.3665 7.32L21.2625 7.848L14.6385 19.4ZM13.6785 14.488C12.8252 14.488 12.1585 14.184 11.6785 13.576C11.1985 12.968 10.9585 12.12 10.9585 11.032C10.9585 9.944 11.1985 9.10133 11.6785 8.504C12.1585 7.896 12.8252 7.592 13.6785 7.592C14.5212 7.592 15.1825 7.896 15.6625 8.504C16.1532 9.10133 16.3985 9.944 16.3985 11.032C16.3985 12.12 16.1532 12.968 15.6625 13.576C15.1825 14.184 14.5212 14.488 13.6785 14.488ZM13.6785 13.544C14.1692 13.544 14.5585 13.336 14.8465 12.92C15.1345 12.4933 15.2785 11.864 15.2785 11.032C15.2785 10.2 15.1345 9.576 14.8465 9.16C14.5585 8.744 14.1692 8.536 13.6785 8.536C13.1772 8.536 12.7825 8.744 12.4945 9.16C12.2172 9.576 12.0785 10.2 12.0785 11.032C12.0785 11.864 12.2172 12.4933 12.4945 12.92C12.7825 13.336 13.1772 13.544 13.6785 13.544ZM21.3265 19.144C20.4838 19.144 19.8172 18.84 19.3265 18.232C18.8465 17.624 18.6065 16.776 18.6065 15.688C18.6065 14.6107 18.8465 13.768 19.3265 13.16C19.8172 12.552 20.4838 12.248 21.3265 12.248C22.1798 12.248 22.8465 12.552 23.3265 13.16C23.8065 13.768 24.0465 14.6107 24.0465 15.688C24.0465 16.776 23.8065 17.624 23.3265 18.232C22.8465 18.84 22.1798 19.144 21.3265 19.144ZM21.3265 18.2C21.8278 18.2 22.2172 17.992 22.4945 17.576C22.7825 17.1493 22.9265 16.52 22.9265 15.688C22.9265 14.856 22.7825 14.232 22.4945 13.816C22.2172 13.4 21.8278 13.192 21.3265 13.192C20.8358 13.192 20.4465 13.4 20.1585 13.816C19.8812 14.232 19.7425 14.856 19.7425 15.688C19.7425 16.5307 19.8812 17.16 20.1585 17.576C20.4465 17.992 20.8358 18.2 21.3265 18.2Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_25032",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_25032"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_25032",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentDashboardIcon);
export default __webpack_public_path__ + "static/media/percent-dashboard-icon.978eaaac7cf942900819bc45c30d96cb.svg";
export { ForwardRef as ReactComponent };